import React, { Component } from "react";
import { withRouter } from "react-router";
import { withStyles } from "material-ui/styles";
import Button from "material-ui/Button";
import Searchbox from "../controls/Searchbox";
import CustomTabs from "../controls/Tabs";
import TabContainer from "../controls/TabContainer";
import Cancel from "material-ui-icons/Cancel";

const styles = theme => ({
  root: {
    padding: 10
  },
  tabHolder: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  tab: {
    boxShadow: "none"
  },
  tabItem: {
    fontSize: "12px"
  },
  indicator: {
    backgroundColor: "#3f51b5"
  },
  wrapper: {
    marginTop: 20,
    position: "relative"
  }
});

class Cheque extends Component {
  state = {
    value: 0
  };

  componentDidMount() {
    if (this.props.history.location.pathname === "/expense") {
      this.setState({ value: 0 });
    } else {
      this.setState({ value: 1 });
    }
  }

  handleChange = (event, value) => {
    if (value === 0) {
      this.props.history.push("/expense");
    } else {
      this.props.history.push("/expensetypes");
    }
    this.setState({ value });
  };

  render() {
    const { classes } = this.props;
    const { value, clearSearch } = this.state;

    return (
      <div className={classes.wrapper}>
        <div>
          <Button
            className={classes.button}
            variant="raised"
            color="default"
            size="small"
            onClick={this.onListClick}
          >
            List
          </Button>

          <Button
            className={classes.button}
            variant="raised"
            color="primary"
            size="small"
            onClick={this.onCreateNewClick}
          >
            Create New
          </Button>
          <Searchbox
            clear={clearSearch}
            onChange={this.onSearchChange}
            onSubmit={this.onSearchSubmit}
          />
        </div>

        <div className={classes.tabHolder}>
        <table className="customtable">
            <thead className="customthead">
            <tr className="customtr">
              <th>Receipt ID</th>
              <th>Receipt Date</th>
              <th>Account</th>
              <th>Amount (RM)</th>
              <th>Bank</th>
              <th>Branch</th>
              <th>Ref No</th>
              <th>Payment Mode</th>
              <th>Contact No</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
            </thead>
            <tr className="customtr">
              <td>19234444303</td>
              <td>12 Jan 2021</td>
              <td>19283746403</td>
              <td>123.22</td>
              <td>Maybank</td>
              <td>Klang</td>
              <td>AOH120938465</td>
              <td>Jom Pay</td>
              <td>012-2394857</td>
              <td>abd@gmail.com</td>
              <td className="button"><Cancel/></td>
            </tr>
            <tr className="customtr">
              <td>19234444303</td>
              <td>23 Mar 2021</td>
              <td>19283746403</td>
              <td>33.00</td>
              <td>Citibank</td>
              <td>Klang</td>
              <td>AOH129338465</td>
              <td>Credit Card</td>
              <td>016-29895857</td>
              <td>aos@gmail.com</td>
              <td className="button"><Cancel/></td>
            </tr>
            <tr className="customtr">
              <td>19258444303</td>
              <td>28 Mar 2021</td>
              <td>19283721803</td>
              <td>123.22</td>
              <td>Citibank</td>
              <td>Klang</td>
              <td>AOH120976465</td>
              <td>eWallet</td>
              <td>018-93746557</td>
              <td>opes@yahoo.com</td>
              <td className="button"><Cancel/></td>
            </tr>
            <tr className="customtr">
              <td>19478044303</td>
              <td>12 Apr 2021</td>
              <td>19283328403</td>
              <td>63.22</td>
              <td>CIMB</td>
              <td>Klang</td>
              <td>AOH196438408</td>
              <td>eWallet</td>
              <td>019-93847562</td>
              <td>saop@live.com</td>
              <td className="button"><Cancel/></td>
            </tr>
            <tr className="customtr">
              <td>13947552303</td>
              <td>18 July 2021</td>
              <td>12266804303</td>
              <td>99.00</td>
              <td>BSN</td>
              <td>Klang</td>
              <td>AOH129336432</td>
              <td>Online Transfer</td>
              <td>016-84953638</td>
              <td>penn@gmail.com</td>
              <td className="button"><Cancel/></td>
            </tr>
          </table>
        </div>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Cheque));



// WEBPACK FOOTER //
// ./src/components/misc/Cheque.js